<template>
 <v-layout
    justify-center
    class="agenda"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
  >
    <v-flex
      xs12
      style="padding-bottom: 0px;padding-top: 0px;padding-left: 20px;padding-right: 20px;"
    >
      <div
        style="padding-top: 15px; padding-bottom: 15px;font-size:22px;"
        class="text-center"
      >
        {{ $t(sDay.pre).toUpperCase() }} {{ $t(sDay.month).toUpperCase() }} {{ sDay.pos.toUpperCase() }}
      </div>
      <div
        style="opacity: 0.8;position: static; height:64px;top:0px;margin-bottom:20px;"
        :style="{ 'background-color': `${BGColor}` }"
      >
        <table border="0" style="width:100%;height:100%;border:0px;" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td" v-for="(day, index) in week" 
              :key="`td${index}`"
              :style="{ 'padding-top': isSimulation || isDesktop ? '20px' : '','background-color': daysToAdd === index ? ColorContent : BGColor, 'border-right': index !== 6 ? '1px solid white' : '0px' }" 
              style="text-align: center;color:white;width:14.19%"
              @click="() => handleAddDays(index)"
            >
              {{ $t(`common.${day}`).substring(0, 2) }}
            </td>
          </tr>
        </table>
      </div>
      <v-container
        fluid
        grid-list-md
        style="padding: 5px"
      >
        <v-layout
          row
          wrap
          style="margin-bottom: 20px;"
        >
          <v-flex
            v-if="!agendas || agendas.length === 0"
            :style="{ 'background-color': ColorContent, 'color': BGColorContent }"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            {{ $t('activity.messages.noActivities').toUpperCase() }}
          </v-flex>
          <v-flex
            v-for="(agenda, index) in agendas"
            :key="agenda.ID"
            v-bind="{ [`xs${!isSimulation && isDesktop ? 6 : 12}`]: true }"
            style="margin-top: 5px;margin-bottom: 6px;"
            :style="{ 'padding-right': index % 2 === 0 && !isSimulation && isDesktop ? '10px' : '0px', 'padding-left': index % 2 !== 0 && !isSimulation && isDesktop ? '10px' : '0px' }"
          >
            <v-card
              :style="{ 'opacity': agenda.Availability.finished ? '0.3' : '1'}"
              style="border-radius:5px;height:100%;min-height:150px;"
            >
              <v-layout
                row
                wrap
                style="height:100%;"
              >
                <v-flex
                  xs4
                  style="padding: 0;height:100%;"
                >
                  <v-img
                    :src="agenda.Image"
                    :lazy-src="agenda.Image"
                    height="100%"
                    width="90%"
                    aspect-ratio="1.7"
                    class="grey lighten-2"
                    style="border-radius: 5px 0 0px 5px;"
                  />
                </v-flex>
                <v-flex
                  :style="{ 'color': ColorContent}"
                  xs8
                >
                  <v-layout
                    row
                    wrap
                    style="margin-top:5px;margin-bottom:0px;"
                  >
                    <v-flex
                      xs8
                      style="text-align: left;padding-bottom:5px;line-height:1.2;"
                    >
                      {{ agenda.Title.toUpperCase() }}
                    </v-flex>                      
                    <v-flex
                      xs4
                      style="text-align: right;padding-right: 15px;padding-bottom:0px;"
                    >
                      <add-calendar
                        v-if="!isSimulation && !isPI"
                        :start="agenda.Date"
                        :end="agenda.Date"
                        :startTime="'00:00'"
                        :endTime="'24:00'"
                        :title="agenda.Title"
                        :description="agenda.Location ? agenda.Location : ''"
                        :color="BGColor"                        
                        :active="false"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      style="text-align: left;padding-top: 0px;padding-bottom: 7px; padding-right:10px;"
                    >
                      <span
                        :style="{ 'opacity': agenda.Location && agenda.Location.length > 0 ? '1' : '0'}"
                        style="font-size: 13px;"
                        v-html="agenda.Location && agenda.Location.length > 0 ? agenda.Location : '.'"
                      >
                      </span>
                    </v-flex>
                    <v-flex
                      v-if="agenda.Description && agenda.Description.length > 0"
                      xs12
                    >
                      <detail :title="agenda.Title" :description="agenda.Description" />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  import AddCalendar from './AddCalendar'
  import Detail from './Detail'
  export default {
    components: {
      Detail,
      AddCalendar
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      DviewLink: null,
      agendas: null,
      daysToAdd: 0,
      week: []
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      sDay () {
        let dToday = new Date()
        const dActual = new Date().setDate(dToday.getDate() + this.daysToAdd)
        const pos = `${new Date(dActual).getDate()}, ${new Date(dActual).getFullYear()}`

        const result = {
          pre: this.daysToAdd === 0 ? 'common.today' : this.daysToAdd === 1 ? 'common.tomorrow' : '',
          month: `common.m${new Date(dActual).getMonth()}`,
          pos
        }
        return result
      }
    },
    mounted () {
      const dSemenaActual = new Date().getUTCDay() - 1
      const aux = []
      for (let i = 0; i < 7; i++) {
        const x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
        aux.push(`s${x}`)
      }
      this.week = aux
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLink = response.DviewLinkAgenda

          this.handleGetAgendas()
        })
      },
      handleAddDays (value) {
        this.daysToAdd = value
        this.handleGetAgendas(this.daysToAdd)
      },
      handleGetAgendas () {
        this.activities = axios.get(`https://www.dviewcontent.com/api/p_event_calendar/${this.DviewLink}?daysToAdd=${this.daysToAdd}`)
          .then(response => {
            this.agendas = response.data ? response.data : []            
          })
      }
    }
  }
</script>
<style scoped>
  .agenda .container {
    padding: 0px;
  }
  .layout.agenda.justify-center {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .agenda .v-toolbar__content {
    padding: 0px !important;
    margin: auto !important;
  }
  .agenda-button {
    margin-left: 10px;
  }
  .agenda-button:hover {
    opacity: 0.7;
  }
  .td:hover {
    cursor: pointer;
  }
</style>
